
export const SET_PINNED_CREDENTIALS = "SET_PINNED_CREDENTIALS";

const initialState = {
    pinnedCredentials: [], 
  };
 
  const pincredentialReducer = (state = initialState, action) => {
    switch (action.type) {
  
      case SET_PINNED_CREDENTIALS:
        return {
          ...state,
          pinnedCredentials: action.payload,
        };
        
      default:
        return state;
    }
  };

  export default pincredentialReducer;
  
